// extracted by mini-css-extract-plugin
export var closeButton = "_9-1";
export var container = "_9-0";
export var fullModalImage = "_9-2";